<template>
    <dragable-popper class="codelab-mission-detail"
    ref="dragableRef"
    :width="expanded ? 376 : 258" 
    :height="expanded ? 536 : 170"
    :right="this.showSimulator ? 'calc(24% + 100px)' : '100px'"
    top="120px"
    :lock="isMissionCrtShow"
    >
        <div slot="title" class="detail-title" :class="shit$(`c:${formatStyleValue(mission.textColor)}!; bgc:${formatStyleValue(mission.bgColor)}!;`)">
            <span class="detail-title-icon" @click.stop="leaveDetail">
                <svg-icon href="#codelab-leave-mission-detail" width="20" height="20"></svg-icon>
            </span>
            <span class="mission-title">
                {{mission.cardNumber}}&nbsp;{{mission.title}}
            </span>
            <span class="detail-title-icon" @click.stop="toggleExpanded">
                <svg-icon v-if="!expanded" href="#codelab-expand-mission-detail" width="20" height="20"></svg-icon>
                <svg-icon v-else href="#codelab-collapse-mission-detail" width="20" height="20"></svg-icon>
            </span>
        </div>
        <div slot="content" class="detail-content" :style="{height: (expanded ? 496 : 130) + 'px'}">
            <el-carousel 
            style="height: 100%;"
            height="100%"
            :autoplay="false" 
            arrow="never"
            :loop="false"
            ref="carousel"
            >
                <el-carousel-item>
                  <el-scrollbar ref="scrollBar1">
                    <el-image 
                      :style="{height: (expanded ? '246px' : '80px') ,lineHeight: expanded ? '246px': '80px'}"
                      class="mission-detail-screenshot"
                      fit="contain"
                      @click="toggleFullScreen(mission.screenshot + queryToken)"
                      :src="mission.screenshot + queryToken"
                      >
                          <div slot="placeholder" class="image-slot">
                              <svg-icon href="#codelab-mission-thumb" width="60" height="60"></svg-icon>
                          </div>
                          <div slot="error" class="image-slot">
                              <svg-icon href="#codelab-mission-thumb-error" width="32" height="32"></svg-icon>
                          </div>
                      </el-image>
                      <div :style="{height: (expanded ? '246px' : '80px')}" class="img-mask" @click="toggleFullScreen(mission.screenshot + queryToken)">
                        <span class="toggle-view-screen">
                            <svg-icon href="#codelab-full-screen" :width="24" :height="24"></svg-icon>
                        </span>
                      </div>

                      <div>
                        <h4 class="mission-detail-title">{{$t("title_mission_story")}}</h4>
                        <p class="mission-detail-text">{{mission.story}}</p>
                        <h4 class="mission-detail-title">{{$t("title_mission_target")}}</h4>
                        <p class="mission-detail-text">{{mission.description}}</p>
                      </div>
                  </el-scrollbar>
                </el-carousel-item>
                <el-carousel-item :style="{paddingBottom: (expanded ? 85 : 35) + 'px'}">
                    <el-scrollbar ref="scrollBar2">
                      <h4 class="mission-detail-title">{{$t("title_mission_description")}}</h4>
                      <p class="mission-detail-text">{{mission.question}}</p>
                      <template v-if="showTips">
                          <h4 class="mission-detail-title">{{$t("popper_title.tips")}}</h4>
                          <p class="mission-detail-text">{{mission.tip}}</p>
                      </template>
                    </el-scrollbar>
                </el-carousel-item>
                <el-carousel-item>
                  <el-scrollbar ref="scrollBar3">
                    <h4 class="mission-detail-title">{{$t("title_mission_answer")}}</h4>
                    <template v-if="mission.answerDesc">
                      <p v-if="expandAnswer || !needShortAnswer" class="mission-detail-text">{{mission.answerDesc}}<span v-if="needShortAnswer" @click="onToggleEaxpandAnswer" class="btn-expand-answer">{{$t("unexpand_answer")}}</span></p>
                      <p v-if="!expandAnswer && needShortAnswer" class="mission-detail-text">{{shortAnswer}}<span class="btn-expand-answer" @click="onToggleEaxpandAnswer">{{$t("expand_answer")}}</span></p>
                    </template>
                    <mission-answer :xml="mission.answer"></mission-answer>
                  </el-scrollbar>
                </el-carousel-item>
                <el-carousel-item :style="{'background-color': missionCorrect ? 'rgba(96, 202, 78, 0.3)': 'rgba(241, 142, 75, 0.3)'}">
                    <el-scrollbar ref="scrollBar4">
                        <div class="mission-answer-status">
                            <img :src="`${env$}static/images/${missionCorrect ? 'graphic-task-card-pass' : 'graphic-task-card-fail'}.png`" alt="">
                            <p v-if="missionCorrect">{{$t("message.success_check_mission")}}</p>
                            <p v-else>{{$t("message.error_check_mission")}}</p>
                            <div class="final-mission">
                                <span v-if="mission.isFinish" class="final-mission-button" @click="playAgain()"  style="margin-right: 15px;">
                                    {{$t("play_mission_onece_again")}}
                                </span>
                                <span ref="getRoudReact2" class="final-mission-button" @click="showMissionAnswer">
                                    {{$t("button_mission_answer")}}
                                </span>
                                <span class="final-mission-button" @click="nextMission" v-if="mission.nextMission && !mission.nextMission.lock$" style="margin-left: 15px;">
                                    {{$t("play_next_mission")}}
                                </span>
                                <span class="final-mission-button" @click="unlockMoreMission" style="margin-left: 15px;" v-else>
                                    {{ isPublic() ? this.$t("code-lab/component/mission/mission-detail.vue_0") : $t("unlock_more_mission") }}
                                </span>
                            </div>
                        </div>
                    </el-scrollbar>
                </el-carousel-item>
            </el-carousel>
            <div class="mission-tools" :class="{hide: !expanded}" v-if="$refs.carousel && $refs.carousel.activeIndex === 1">
                <span>
                    <span
                    class="mission-tool-button"
                    @click="beforeRefreshMission(true, true)">
                        <svg-icon href="#codelab-mission-tool-refresh" :width="15" :height="15"></svg-icon>
                        {{expanded ? $t("button_refresh_mission") : ""}}
                    </span>
                    <span
                    class="mission-tool-button"
                    :class="{'active': showTips}"
                    style="margin-left:8px;"
                    @click="onToggleTips('tips')"
                    >
                        <svg-icon href="#codelab-mission-tool-tip" :width="15" :height="15"></svg-icon>
                        {{expanded ? $t("popper_title.tips"): ""}}
                    </span>
                </span>
                <span
                ref="getRoudReact1" 
                class="mission-tool-button show-answer" 
                style="position: absolute;right:24px;top:12px;" 
                @click="checkMissionAnswer"
                >
                    {{$t("button_send_answer")}}
                </span>
            </div>
        </div>
        <template v-if="showCarouselController">
            <span v-if="showPrev" class="carsousel-controller left" @click="prev">
                <svg-icon href="#codelab-icon-prev" width="11" height="18" color="#ffffff"></svg-icon>
            </span>
            <span ref="getRoudReact" v-if="showNext" class="carsousel-controller right" @click="next">
                <svg-icon href="#codelab-icon-next" width="11" height="18" color="#ffffff"></svg-icon>
            </span>
        </template>
        <full-image-preview v-if="fullScreen" style="z-index: 10000;" :visible.sync="fullScreen" :url="fullImageUrl"></full-image-preview>
    </dragable-popper>
</template>
<script>
import dragablePopper from "@/code-lab/view/dragable-popper.vue";
import missionAnswer from "@/code-lab/component/mission/mission-answer.vue";
import fullImagePreview from "@/code-lab/view/full-image-preview.vue";
import IndexMixGroceryStore from "@/code-lab/component/mixins/indexMixStore.js";
import { mapState } from "vuex";
const Blockly = window.Blockly;
const apiKey = process.env.VUE_APP_api_key;
const nuwa = window.nuwa;

export default {
  name: "mission-detail",
  mixins: [IndexMixGroceryStore],
  components: {
    dragablePopper,
    missionAnswer,
    fullImagePreview
  },
  props: {
    mission: Object
  },
  data () {
    return {
      expanded: true,
      showCarouselController: false,
      missionCorrect: false,
      showTips: false,
      showAnswer: false,
      expandAnswer: false,
      fullScreen: false,
      fullImageUrl: "",
      setSaveStateTimer: null,
      queryToken: "?apiKey=" + apiKey,
      hasTaskRouteVersion: ["public", "family"]
    };
  },
  computed: {
    ...mapState('introStore', { isMissionCrtShow: o => o.currentExe === 'missionDB' && o.show }),
    ...mapState([
      "showSimulator",
      "workSpace",
      "projectData",
      "isSaved",
      "materialsList",
      "currentVersion",
      "env$"
    ]),
    isPublicVersion() {
      return this.currentVersion === "public";
    },
    showPrev(){
      let carousel = this.$refs.carousel,activeIndex;
      if(carousel){
        activeIndex = carousel.activeIndex;
        if([1,2].includes(activeIndex)){
          return true;
        }
        if(activeIndex === 3 && this.showAnswer){
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    showNext(){
      let carousel = this.$refs.carousel,activeIndex;
      if(carousel){
        activeIndex = carousel.activeIndex;
        if([0,2].includes(activeIndex)){
          return true;
        }
        if(activeIndex === 1 && this.showAnswer){
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    shortAnswer(){
      let answer = this.mission.answerDesc || "";
      if(answer.length > 32){
        return answer.substr(0, 24) + "...";
      }
      return answer;
    },
    needShortAnswer(){
      if(this.shortAnswer && this.shortAnswer !== this.mission.answerDesc){
        return true;
      }
      return false;
    },
  },
  watch: {
    showCarouselController (n) {
      if (!n) return
      this.$nextTick(() => {
        if (this.showNext) {
          this.executeIntro_([ [ {
            stack: [{ index: 0, md: 'right', target: this.$refs.getRoudReact, position: 'right', type: 'circle_', clientH: 231, clientW: 420, offsetRct: 8, cc: 15, data: {
              header_t1: this.$t("code-lab/component/mission/mission-detail.vue_1"),
              header_t2: this.$t("code-lab/component/mission/mission-detail.vue_2"),
              content_t1: this.$t("code-lab/component/mission/mission-detail.vue_3"),
              btn_t1: this.$t("code-lab/component/mission/mission-detail.vue_4"),
            } }, ]
          } ], [ { type: 'missionDB', index: 0 } ] ])
        }
      })
    },
    expanded() {
      setTimeout(() => {
        if (this.$refs.scrollBar1) {
          this.$refs.scrollBar1.update();
        }
        if (this.$refs.scrollBar2) {
          this.$refs.scrollBar2.update();
        }
        if (this.$refs.scrollBar3) {
          this.$refs.scrollBar3.update();
        }
        if (this.$refs.scrollBar4) {
          this.$refs.scrollBar4.update();
        }
      }, 400);
    },
    expandAnswer(){
      this.$nextTick(() => {
        if (this.$refs.scrollBar3) {
          this.$refs.scrollBar3.update();
        }
      });
    }
  },
  created() {
    this.$nextTick(() => {
      let mission = this.mission;
      let script;
      if (mission.isFinish) {
        script = mission.answer;
      } else {
        script = mission.script || mission.codeModule;
      }
      this.$store.commit("UPDATE_PROJECT_DATA", {
        name: mission.title,
        projectId: mission.projectId || null,
        materials: mission.materials || []
      });
      this.$nextTick(() => {
        this.updateXml2WorkSpace(script);
        this.refreshSaveState(true, false);
      });
    });
  },
  mounted() {
    this.$nextTick(() => {
      this.showCarouselController = true;
      this.subscribRootEvent();
      this.$watch("materialsList", {
        handler(value) {
          this.updateMissionData({
            materials: value
          });
        }
      });
    });
  },
  methods: {
    executeIntro_ ([ data, disp ]) {
      if ( (localStorage.getItem('missionDB')) ) return
      this.$refs.dragableRef.reset()
      this.$nextTick(() => {
        this.$store.commit('introStore/updMissionDB', data)
        this.$store.dispatch('introStore/excuteStackMission_', disp)
      })
    },
    formatStyleValue (styleVal) {
        return styleVal.indexOf(',') > -1 ? `rgba(${styleVal})` : styleVal
    },
    isPublic() {
      return this.currentVersion === "public";
    },
    subscribRootEvent() {
      this.$root.$on("updateMission", this.updateMission);
    },
    backToTask() {
      this.$store.commit("SELECTEDMENUERIGHT", "mission");
      if (!this.hasTaskRouteVersion.includes(this.currentVersion)) return
      this.$router.push({ name: "task" });
    },
    leaveDetail() {
      if (!this.isSaved && !this.isPublic()) {
        let message = `<div class="tip-icon">
                        <svg width="150" height="150">
                            <use xlink:href="#codelab-project-unsaved"></use>
                        </svg>
                    </div>
                    ${this.$t("message.warn_before_leave_mission")}
                `;
        this.$confirm(message, this.$t("popper_title.unsaved_mission"), {
          dangerouslyUseHTMLString: true,
          center: true,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          cancelButtonClass: "codelab-button btn",
          confirmButtonClass: "codelab-button gray",
          cancelButtonText: this.$t("button.open_mission"),
          confirmButtonText: this.$t("button.not_leave_now"),
          customClass: "codelab-important-tip project-unsaved"
        }).catch(() => {
          this.$store.commit("SET_CURRENT_MISSION", null);
          this.$store.commit("SHOW_MISSION_LIST", true);
          this.backToTask();
          
        });
      } else {
        this.$store.commit("SET_CURRENT_MISSION", null);
        this.$store.commit("SHOW_MISSION_LIST", true);
        this.backToTask();
      }
      this.$store.commit('introStore/upShow', [ false ])
      this.$store.commit('introStore/upShowBlockWindow', [ false ])
    },
    toggleExpanded() {
      if (this.isMissionCrtShow) return
      if (this.$refs.carousel && this.$refs.carousel.activeIndex >= 2) {
        return;
      } else {
        this.expanded = !this.expanded;
      }
    },
    prev() {
      if (this.$refs.carousel) {
        this.$refs.carousel.prev();
      }
    },
    next() {
      if (this.$refs.carousel) {
        this.$refs.carousel.next();
        this.$nextTick(() => {
          if (!localStorage.getItem('missionDB')) {
            this.expanded = true
          }
          this.executeIntro_([ [ {
            stack: [{ index: 1, md: 'right', target: this.$refs.getRoudReact1, position: 'right', type: 'rect_', clientH: 231, clientW: 420, offsetRct: 8, rr: 15, data: {
                header_t1: this.$t("code-lab/component/mission/mission-detail.vue_5"),
                header_t2: this.$t("code-lab/component/mission/mission-detail.vue_6"),
                content_t1: this.$t("code-lab/component/mission/mission-detail.vue_7"),
                btn_t1: this.$t("code-lab/component/mission/mission-detail.vue_8"),
              } }, ]
          } ], [ { type: 'missionDB', index: 1 } ]  ])
        })
      }
    },
    onToggleTips() {
      this.showTips = !this.showTips;
      this.$nextTick(() => {
        if (this.$refs.scrollBar3) {
          this.$refs.scrollBar3.update();
        }
      });
    },
    onToggleEaxpandAnswer(){
      this.expandAnswer = !this.expandAnswer;
    },
    showMissionAnswer(){
      this.showAnswer = true;
      this.$nextTick(() => {
        this.setActiveItem(2);
      });
    },
    toggleFullScreen(url = "") {
      this.fullScreen = !this.fullScreen;
      this.fullImageUrl = url;
    },
    playAgain() {
      if (this.mission.isFinish) {
        this.refreshMission(false);
        this.$nextTick(() => {
          this.setActiveItem(0);
        })
      }
    },
    beforeRefreshMission(updateMission = false, checkSave = false) {
      if (this.mission) {
        if (checkSave && !this.isSaved && !this.isPublicVersion) {
          this.showUnsavedTips(4)
            .then(() => {
              this.refreshMission(updateMission);
            })
            .catch(() => {});
        } else {
          this.refreshMission(updateMission);
        }
      }
    },
    refreshMission(updateMission = false) {
      this.updateXml2WorkSpace(this.mission.codeModule);
      this.showAnswer = false;
      if (updateMission) {
        this.updateMission(this.mission.codeModule, false);
      } else {
        this.refreshSaveState(true, false);
      }
    },
    nextMission() {
      if(this.mission.nextMission && !this.mission.nextMission.lock$){
        this.$emit("nextMission");
      }
    },
    unlockMoreMission() {
      if (this.isPublic()) {
        return window.open(this.util$.getNuwaWebsite());
      }
      this.$emit("unlockMoreMission");
    },
    updateMission(scriptXml, showTips = true) {
      return new Promise((resolve, reject) => {
        let { projectId, missionId, isFinish, title: name } = this.mission;
        scriptXml = scriptXml || this.projectData.script;
        let script;
        if (scriptXml) {
          script = nuwa.utils.base64.encode(scriptXml);
        }
        if (!this.isPublicVersion) {
          let cmd = projectId ? "edit_project" : "add_project";
          let data;
          if (projectId) {
            data = {
              projectId,
              isFinish,
              script
            };
          } else {
            data = {
              missionId,
              name,
              script,
              isFinish
            };
          }
          this.b$.send(
            "tool",
            {
              cmd,
              data
            },
            res => {
              console.log(res)
              if (res.status && Number(res.status.code) === 0) {
                let { projectId } = res.data;
                this.updateMissionData({
                  projectId,
                  isFinish,
                  script: scriptXml
                });
                this.refreshSaveState(true, false);
                showTips &&
                  this.$message.success(
                    this.$t("message.success_update_mission")
                  );
                  resolve();
              } else {
                showTips &&
                  this.$message.error(this.$t("message.error_update_mission"));
                  reject();
              }
            }
          );
        } else {
          this.updateMissionData({ script: scriptXml });
          resolve();
        }
      })
    },

    checkMissionAnswer () {
      this.$nextTick(() => {
        this.executeIntro_([ [ {
          stack: [{ index: 2, md: 'right', target: this.$refs.getRoudReact2, position: 'right', type: 'rect_', clientH: 231, clientW: 420, offsetRct: 8, rr: 15,  data: {
                header_t1: this.$t("code-lab/component/mission/mission-detail.vue_9"),
                header_t2: this.$t("code-lab/component/mission/mission-detail.vue_10"),
                content_t1: this.$t("code-lab/component/mission/mission-detail.vue_11"),
                content_t2: this.$t("code-lab/component/mission/mission-detail.vue_12"),
                content_t2_shit: 'c:#e44e4e; dis:b;',
                btn_t1: this.$t("code-lab/component/mission/mission-detail.vue_13"),
            }, to: () => this.$store.dispatch('introStore/excuteStackMission_', [ { type: 'missionDB' }, 1 ]) }, ]
        } ], [ { type: 'missionDB', index: 2 } ] ])
      })
      
      this.markErrorBlock(null);
      let customerXml = Blockly.Xml.workspaceToDom(this.workSpace);
      customerXml = Blockly.Xml.textToDom(Blockly.Xml.domToText(customerXml))
      let answerXml = Blockly.Xml.textToDom(this.mission.answer)

      let diffBlock = this.getFirstDiffBlock(customerXml, answerXml);
      if (diffBlock) {
        this.markErrorBlock(diffBlock.getAttribute("id"));
        this.missionCorrect = false;
        setTimeout(() => {
          this.markErrorBlock(null);
        }, 4000);
      } else {
        this.missionCorrect = true;
        this.updateMissionData({ isFinish: true });
        if(this.currentVersion !== "public"){
          this.$nextTick(() => {
            this.updateMission(null, false);
          });
        }
      }
      this.$nextTick(() => {
        this.setActiveItem(3);
      });
    },
    updateMissionData(payload) {
      let mission = Object.assign({}, this.mission, payload);
      this.$store.commit("SET_CURRENT_MISSION", mission);
      this.$emit("updateMissionData", mission);
      if (payload.projectId !== undefined) {
        this.$store.commit("UPDATE_PROJECT_DATA", {
          projectId: payload.projectId
        });
      }
    },
    setActiveItem(index = 0){
      if(index > 1 && !this.expanded){
        this.expanded = true;
      }
      this.$refs.carousel && this.$refs.carousel.setActiveItem(index);
    },
    getFirstDiffBlock(xml1, xml2) {
      xml1 = typeof xml1 === "object" ? xml1 : Blockly.Xml.textToDom(xml1);
      xml2 = typeof xml2 === "object" ? xml2 : Blockly.Xml.textToDom(xml2);
      if (
        xml1.nodeType === Node.ELEMENT_NODE &&
        xml2.nodeType === Node.ELEMENT_NODE
      ) {
        let shadowChild = this.getChildTagName(xml1, "shadow");
        let blockChild = this.getChildTagName(xml1, "block");
        if (shadowChild && blockChild) {
          xml1.removeChild(shadowChild);
        }
        shadowChild = this.getChildTagName(xml2, "shadow");
        blockChild = this.getChildTagName(xml2, "block");
        if (shadowChild && blockChild) {
          xml2.removeChild(shadowChild);
        }
        let childLen1 = xml1.children.length;
        let childLen2 = xml2.children.length;
        let diffBlock = null;
        for (let i = 0, len = Math.max(childLen1, childLen2); i < len; i++) {
          let node1 = xml1.children[i];
          let node2 = xml2.children[i];
          if (!node1) {
            diffBlock = this.getParentBlock(xml1);
            break;
          } else if (!node2) {
            diffBlock = this.getParentBlock(node1);
            break;
          } else {
            let isSame = this.isNodeSame(node1, node2);
            if (!isSame) {
              diffBlock = this.getParentBlock(node1);
              break;
            } else {
              diffBlock = this.getFirstDiffBlock(node1, node2);
              if (diffBlock) {
                break;
              }
            }
          }
        }
        return diffBlock;
      } else if (
        xml1.nodeType === Node.TEXT_NODE &&
        xml2.nodeType === Node.TEXT_NODE
      ) {
        if (xml1.textContent !== xml2.textContent) {
          return this.getParentBlock(xml1);
        } else {
          return null;
        }
      } else {
        return this.getParentBlock(xml1);
      }
    },
    isNodeSame(node1, node2) {
      if (node1.nodeType !== node2.nodeType) {
        return false;
      } else {
        let tagName1 = node1.tagName.toLowerCase();
        let tagName2 = node2.tagName.toLowerCase();
        if (tagName1 !== tagName2) {
          if (
            !["block", "shadow"].includes(tagName1) &&
            !["block", "shadow"].includes(tagName2)
          ) {
            return false;
          }
        }
        let isSame = true;
        switch (tagName1) {
          case "block":
          case "shadow":
            if (node1.getAttribute("type") !== node2.getAttribute("type")) {
              isSame = false;
            }
            break;
          case "value":
          case "statement":
            if (node1.getAttribute("name") !== node2.getAttribute("name")) {
              isSame = false;
            }
            break;
          case "field":
            if (node1.getAttribute("name") !== node2.getAttribute("name")) {
                "other_function_camera",
                "other_function_video",
                "function_video_youtube",
                "sound_record";
              isSame = false;
            } else {
              if (
                [
                  "other_function_camera",
                  "other_function_video",
                  "function_video_youtube",
                  "sound_record"
                ].includes(node1.parentNode.getAttribute("type"))
              ) {
                if (node1.textContent === "" && node2.textContent !== "") {
                  isSame = false;
                }
              } else if (node1.textContent !== node2.textContent) {
                isSame = false;
              }
            }
            break;
        }
        return isSame;
      }
    },
    getParentBlock(node) {
      let parentNode = null;
      if (
        node.nodeType === Node.ELEMENT_NODE &&
        (node.tagName.toLowerCase() === "block" ||
          node.tagName.toLowerCase() === "shadow")
      ) {
        parentNode = node;
      } else {
        while (node.parentNode && !parentNode) {
          node = node.parentNode;
          parentNode = this.getParentBlock(node);
        }
      }
      return parentNode;
    },
    markErrorBlock(blockId) {
      let blocklyCanvas = document.querySelector(
        "#blockly-container .injectionDiv .blocklySvg .blocklyBlockCanvas"
      );
      
      
      if (blockId) {
        let errorBLock = blocklyCanvas.querySelector(
          "g[data-id='" + blockId + "']"
        );
        errorBLock && errorBLock.classList.add("blocklyError");
      } else {
        let errorBLocks = blocklyCanvas.querySelectorAll(".blocklyError");
        for (let i = 0, len = errorBLocks.length; i < len; i++) {
          errorBLocks[i].classList.remove("blocklyError");
        }
      }
    },
    getChildTagName(node, tagName) {
      let childNode = node.querySelector(tagName);
      if (childNode && childNode.parentNode === node) {
        return childNode;
      } else {
        return null;
      }
    },
    refreshSaveState(isSaved) {
      if (this.setSaveStateTimer) {
        clearTimeout(this.setSaveStateTimer);
        this.setSaveStateTimer = null;
      }
      this.setSaveStateTimer = setTimeout(() => {
        this.$store.commit("UPDATE_IS_SAVED", isSaved);
      }, 200);
    },
    updateXml2WorkSpace(xml) {
      if (typeof xml === "string") {
        xml = Blockly.Xml.textToDom(xml);
      }
      Blockly.Xml.hardDomToWorkspace(xml, this.workSpace);
    }
  },
  destroyed() {
    this.workSpace.clear();
    this.$store.commit("UPDATE_PROJECT_DATA", {
      name: ""
    });
    this.refreshSaveState(true, false);
    this.$root.$off("updateMission", this.updateMission);
  }
};
</script>

<style lang="scss">
.codelab-mission-detail {
    max-height: 100%;
  overflow: visible;
  transition: height ease-out 0.3s;
  .popper-content{
      height: calc(100% - 40px);
  }
  .detail-title {
    height: 40px;
    line-height: 40px;
    
    position: relative;
    padding: 0 12px;
    font-size: 18px;
    
    display: flex;
    align-items: center;
    justify-content: space-between;
    .detail-title-icon {
      flex: 0 0 auto;
      display: inline-block;
      width: 24px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      cursor: pointer;
      pointer-events: all;
      svg {
        fill: #ffffff;
      }
      &:hover,
      &:active {
        svg {
          fill: $--codelab-primary-blue-1;
        }
      }
    }
    .mission-title {
      flex: 1 1 auto;
      padding: 0 12px;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .el-scrollbar__view{
      position: relative;
  }
  .detail-content {
    width: 100%;
    height: 296px;
    max-height: calc(100% - 40px);
    overflow: hidden;
    transition: height ease-out 0.3s;
    position: relative;
    .el-carousel {
      .el-carousel__arrow {
        &.el-carousel__arrow--left {
          left: -18px;
        }
        &.el-carousel__arrow--right {
          right: -18px;
        }
      }
      .el-carousel__indicators {
        z-index: 6;
        pointer-events: none;
        .el-carousel__indicator {
          pointer-events: none;
          cursor: default;
          .el-carousel__button {
            width: 7px;
            height: 7px;
            border-radius: 3.5px;
            background: #d8d8d8;
          }
          &.is-active {
            .el-carousel__button {
              background: $--codelab-primary-gray-3;
            }
          }
        }
      }
      .el-carousel__item {
        padding: 15px 20px 35px 20px;
        .img-mask{
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          .toggle-view-screen {
            display: none;
            position: absolute;
            top: 50%;
            left: 50%;
            width: 40px;
            height: 40px;
            background-color: rgba(69, 229, 244, 1);
            border-radius: 20px;
            text-align: center;
            line-height: 40px;
            font-size: 0;
            margin-left: -20px;
            margin-top: -20px;
            pointer-events: none;
            svg {
              fill: #333333;
            }
          }
          &:hover{
            .toggle-view-screen{
              display: block;
            }
          }
        }
        .el-scrollbar {
          width: 100%;
          height: 100%;
          .el-scrollbar__wrap {
            overflow-x: hidden;
            .el-scrollbar__view {
              padding: 0 17px;
            }
          }
        }
        .mission-detail-title {
          font-size: 18px;
          color: #29bde5;
          line-height: 22px;
          margin-top: 30px;
        }
        .mission-detail-text {
          font-size: 18px;
          color: #000000;
          line-height: 28px;
          margin-top: 10px;
          white-space: pre-wrap;
        }
        .final-mission {
          width: 100%;
          overflow: hidden;
          padding: 14px 0px;
          margin-top: 28px;
          .final-mission-button {
            display: inline-block;
            width: 100px;
            height: 40px;
            line-height: 40px;
            border-radius: 10px;
            white-space: nowrap;
            text-overflow: ellipsis;
            box-shadow: 0 0 5px 0 rgba(31, 31, 31, 0.5);
            background-color: #ffffff;
            font-size: 14px;
            cursor: pointer;
            &:not(.disabled) {
              &:hover{
                color: #ffffff;
                background-color: $--codelab-primary-blue-1;
              }
              &:active {
                background-color: #c8c8c8;
              }
            }
            &.disabled {
              color: $--codelab-primary-gray-3;
              background: #d8d8d8;
              cursor: default;
            }
            .screenshot {
              width: 100%;
              height: 112px;
              line-height: 160px;
              background: #ffffff;
              text-align: center;
              margin-top: 10px;
            }
            .label {
              font-size: 14px;
              line-height: 42px;
              text-align: center;
            }
          }
        }
        .mission-detail-screenshot {
          cursor: pointer;
          text-align: center;
        }
      }
    }
    .mission-answer-status{
      text-align: center;
      color: #333333;
      &.mission-correct{
        background-color: rgba(96, 202, 78, 0.3);
      }
      &>p{
        font-size: 18px;
        line-height: 1.22em;
        text-align: left;
        padding: 20px;
      }
    }
    .mission-tools {
      width: 100%;
      height: 85px;
      padding: 12px 24px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #ffffff;
      transition: all ease-out 0.2s;
      z-index: 4;
      &.hide {
        height: 54px;
        bottom: -28px;
        background: transparent;
        opacity: 0;
        &:hover {
          opacity: 1;
          background-color: #ffffff;
          bottom: 0;
        }
      }
      .mission-tool-button {
        display: inline-block;
        height: 30px;
        padding: 0 8px;
        line-height: 28px;
        text-align: center;
        font-size: 14px;
        color: $--codelab-primary-black-2;
        cursor: pointer;
        border-radius: 12.5px;
        background-color: #c8c8c8;
        border: 1px solid transparent;
        vertical-align: middle;
        svg {
          fill: $--codelab-primary-black-2;
        }
        &.show-answer{
          background-color: #0ed3ff; 
          color: #ffffff;
        }
        &:hover {
          background: $--codelab-primary-blue-3;
          border: solid 1px $--codelab-primary-blue-1;
          svg {
            fill: #333333;
          }
        }
        &.active,
        &:active {
          background: $--codelab-primary-blue-3;
          border: solid 1px $--codelab-primary-blue-1;
          svg {
            fill: #333333;
          }
        }
      }
    }
  }
  .carsousel-controller {
    display: block;
    width: 35px;
    height: 35px;
    border-radius: 16.5px;
    line-height: 35px;
    font-size: 0;
    text-align: center;
    background: $--codelab-primary-blue-1;
    position: absolute;
    top: 50%;
    z-index: 5;
    cursor: pointer;
    &.left {
      left: -16.5px;
    }
    &.right {
      right: -16.5px;
    }
    &:hover,
    &:active {
      background: #00e0da;
    }
  }
  .el-image {
    width: 100%;
    height: 100%;
    .image-slot {
      display: inline-block;
    }
  }
  .btn-expand-answer{
    padding-left: 8px;
    font-size: 18px;
    color: #8e8e91;
    cursor: pointer;
    text-decoration: underline;
    &:hover{
      color: $--codelab-primary-blue-1;
    }
  }
}
</style>